function selectIsFavouritesEnabled(state) {
  return state.rootDescriptors.some(descriptor => descriptor.type === "ThemePortalFrontPage");
}

export { selectIsFavouritesEnabled };
//# sourceMappingURL=util.is-enabled.js.map
